import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DocumentLibraryConstants } from '../../document-library-constants';
import { DocumentPhaseChange } from '../../models/documentPhaseChange';
import { DocumentService } from '../../services/document.service';

@Component({
  selector: 'app-uncancel-button',
  templateUrl: './uncancel-button.component.html',
  styleUrls: ['./uncancel-button.component.scss']
})
export class UncancelButtonComponent implements OnInit {
  @Input() documentPhase!: number;
  @Input() documentNumber!: string;
  @Input() documentVersion!: string;  
  showUncancelButton: boolean = false;
  uncancelButton !: DocumentPhaseChange
  @Output() setDocumentDetailsLoader = new EventEmitter<any>();

  constructor(private documentService: DocumentService, private messageService: MessageService) { }

  ngOnInit(): void {
    this.uncancelButton={
      reason:"",
      phase:0
    }
  }

  documentCollaborationPhase(){
    this.setDocumentDetailsLoader.emit(true);
    this.documentService.moveDocumentToUncancel(this.documentNumber,this.documentVersion)
    .subscribe(
      (serviceData)=>{
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Info,
          summary: `${DocumentLibraryConstants.MoveToCollaborationPhase_Success}`
        });
        setTimeout(() => {
        this.setDocumentDetailsLoader.emit(false);
        }, 3000)
    });
  }

}
